import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MenuController, NavController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(
    private authService: AuthService,
    private navController: NavController
  ) {
    this.loader$.pipe(debounceTime(300)).subscribe(loader => {
      this.loader = loader;
    });
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      if (!this.authService.isEmptyObject(route.queryParams)) {
        this.authService.setParams(route.queryParams);
      }
      const isLogged = await this.authService.checkAuthentication();

      if (!isLogged) {
        this.navController.navigateRoot('/login');
        return false;
      }
      const user = this.authService.getAppUser();
      const hasLicense = !!user?.has_license;
      const isHome = state.url === '/home' || state.url === '/';
      if (!hasLicense && !isHome) {
        this.navController.navigateRoot('/home');
        return false;
      }
      return true;

    } catch (error) {
      this.navController.navigateRoot('/login');
      return false;
    }
  }
}
